import React, { useEffect, useState, useRef } from "react";
import DataTablePaginationServer from "../../../Components/DataTable/DataTablePaginationServer";
import { ButtonAdd, ButtonEdit, ButtonDelete} from "../../../Components/Button/Button";
import AddWorkArea from "./AddWorkArea";
import Loading from "../../../Components/Loading/Loading";
import { useRecoilValue, useRecoilState } from "recoil";
import { userData } from "../../../DataContext/DataContext";
import {
  AlertError,
  AlertSuccess,
  AlertWarning,
} from "../../../Components/AlertDialog/AlertDialog";
import axios from "axios";
import { authorization, UrlApi } from "../../../UrlApi/UrlApi";
import Card from "@mui/material/Card";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import DateRange from "../../../Components/DateRange/DateRange";
import { TextInput } from "../../../Components/Input/Input";
import moment from "moment/moment";
import { InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ButtonOther } from "../../../Components/Button/Button";
import ImgExcell from "../../../Assets/Images/excel.png";
import * as SiIcons from "react-icons/si";
import RefreshIcon from "@mui/icons-material/Refresh";
import CancelIcon from "@mui/icons-material/Cancel";
import ExportExcel from "../../../Components/ExportExcel/ExportExcel";
import { AlertConfirm } from "../../../Components/AlertDialog/AlertDialog";
import DataTable from "../../../Components/DataTable/DataTable";
import Chip from "@mui/material/Chip";

function WorkArea(props) {
    const user = useRecoilValue(userData);
    const [openDialogformEdit, setOpenDialogformEdit] = useState(false);
    const [openDialogformAdd, setOpenDialogformAdd] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadData, setLoadData] = useState(false);
    const [areaData, setAreaData] = useState([]);
    const refContainer = useRef(null);
    const [date, setDate] = useState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ]);
    const tableRef = useRef();
    const [variable, setVariable] = useState({
        startDate : new Date(),
        endDate : new Date(),
        search: "",
        documentData: [],
        documentId: "",
        page: 0,
        pageSize: 50,
        countRowData: 0
    });
  
  const getData = async (search) => {
    const url =
      UrlApi +
      `get_area_work_data?search=${search}`;
    await axios
      .get(url, authorization)
      .then((res) => {
        res.data.map((item, index)=>{
            item.list_no = index + 1;
        });
        setAreaData(res.data);
      })
      .catch((err) => {
        AlertError(err);
      });
  };

  const filteredItems = areaData.filter(
    item => JSON.stringify(item).toLowerCase().indexOf(variable.search.toLowerCase().trim()) !== -1
  );

  useEffect(() => {
    document.addEventListener("keydown", detextKeyDown, true);
    getData(variable.search);
  }, [openDialogformAdd === false, openDialogformEdit === false, loadData]);

  const detextKeyDown = (e) => {
    if (e.key === "F9") {
      variable.openDialogformAdd = true;
      return false;
    }
  };

  const columns = [
    {
      title: "เปิด",
      field: "order_area_id",
      filtering: false,
      export: false,
      headerStyle: {
        width: 1,
        maxWidth: 1,
      },
      cellStyle: { width: 1, maxWidth: 1 },
      render: (rowData) => (
        <ButtonEdit
          onClick={() => {
            variable.documentId = rowData.order_area_id;
            setOpenDialogformEdit(true);
          }}
        />
      ),
    },
    {
      title: "ลำดับ",
      field: "list_no",
      filtering: false,
      headerStyle: {
        width: "10px",
        maxWidth: "10px",
      },
      cellStyle: { width: "5px", maxWidth: "5px" },
    },
    {
      title: "พื้นที่สั่งงาน",
      field: "order_area_name",
      headerStyle: {
        width: "8rem",
        maxWidth: "8rem",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "โซน",
      field: "zone_master_name",
      headerStyle: {
        width: "8rem",
        maxWidth: "8rem",
      },
      cellStyle: { width: "8rem", maxWidth: "8rem" },
    },
    {
        title: "หมายเหตุ โซน",
        field: "zone_master_remark",
        headerStyle: {
          width: "10rem",
          maxWidth: "10rem",
        },
        cellStyle: { width: "10rem", maxWidth: "10rem" },
      },
      {
        title: "สถานะการใช้งาน",
        field: "order_area_active",
        render: (rowData) => {
            let color = "";
            let fontColor = "#FFFFFF";
            let label = "";
            switch (rowData.order_area_active) {
                case true:
                    color = "#92CEA8";
                    label = "เปิดการใช้งาน";
                    break;
                default:
                    color = "#F898A4";
                    label = "ปิดการใช้งาน";
            }
            return (
                <Chip
                    label={label}
                    style={{
                        background: color,
                        color: fontColor,
                        fontFamily: "Sarabun",
                    }}
                />
            );
        },
        headerStyle: {
            width: "70%",
            maxWidth: "70%",
        },
        cellStyle: { width: "70%", maxWidth: "70%" },
    },
  ];

  const HeaderPage = () => {
    return (
      <>
        <div style={{ paddingTop: "10px" }}>
          <label
            style={{ marginLeft: "10px", marginTop: "10px", fontSize: "18px" }}
          >
            พื้นที่สั่งงาน
          </label>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
              }}
            >
              {/* {datePicker()} */}
             <div style={{marginLeft: ''}}>
              <ButtonAdd
                  label="เพิ่ม"
                  variant="contained"
                  onClick={() => {
                    setOpenDialogformAdd(true);
                  }}
                />
             </div>
              <ButtonOther
                  onClick={() => {
                    getData(variable.search);
                  }}
                  message="โหลดข้อมูลใหม่"
                  width="20ch"
                  startIcon={<RefreshIcon />}
                  background="#61C495"
                />
            </div>
            <div
              style={{
                display: "flex",
              }}
            >
              <div style={{ marginRight: "12px", marginTop: "2px" }}>
                <TextInput
                  width="100%"
                  placeholder="ค้นหา พื้นที่สั่งงาน"
                  onKeyDown={(e) => {}}
                  value={variable.search}
                  onChange={(e) => {
                    variable.search = e.target.value;
                    getData(e.target.value);                          
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          variable.search = "";
                          variable.page = 0;
                          getData("");  
                        }}
                        edge="end"
                      >
                        <CancelIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </div>
              {
                <ButtonOther
                  onClick={() => {
                    exportExcells();
                  }}
                  message="ส่งออก"
                  width="15ch"
                  startIcon={<SiIcons.SiMicrosoftexcel />}
                  
                />
              }
            </div>
          </div>
        </div>
      </>
    );
  };

  function datePicker() {
    return (
      <>
        <DateRange
          onClick={(date) => {
            variable.startDate = date[0].startDate;
            variable.endDate = date[0].endDate;
            getData(variable.search);
          }}
        />
      </>
    );
  }

  // const exportExcells = () => {
  //   let columnExport = [];
  //   columns.map((item) => {
  //     if (item.title !== "เปิด" && item.title !== "ลบ") {
  //       columnExport.push(item.title);
  //     }
  //   });

  //   const header = [
  //     "",
  //     "รายงานประจำวันที่ " +
  //       moment(date[0].startDate).format("DD/MM/YYYY") +
  //       " ถึง " +
  //       moment(date[0].endDate).format("DD/MM/YYYY"),
  //   ];
  //   const data = documentData.map((item) => {
  //     return [
  //       item.list_no,
  //       item.listno_order,
  //       item.emp_name,
  //       item.emp_code,
  //       item.sale_name,
  //       item.order_area_name,
  //       item.zone_master_name,
  //       item.remark
  //     ];
  //   });
  //   ExportExcel(
  //     data,
  //     columnExport,
  //     "ข้อมูลงานเข้าประจำวัน DGF Express",
  //     "ข้อมูลงานเข้าประจำวัน DGF Express.xlsx",
  //     header,
  //   );
  // };
  const columnsExport = [
    {
      title: "ลำดับ",
    },
    {
      title: "พื้นที่สั่งงาน",
    },
    {
      title: "โซน",
    },
    {
      title: "หมายเหตุ โซน",
    },
    {
      title: "สถานะการใช้งาน",
    },
  ];

  const exportExcells = async () => {
    const workSheetColumnsName = columnsExport.map((item) => {
      return [
        item.title
      ];
    });
  
    setLoading(true);
    await axios
      .get(
        UrlApi +
        `get_area_work_data?search=${variable.search}`,
        authorization
      )
      .then((res) => {
        if (res.data.length > 0) {
          const data = res.data.map((item, index) => {
            item.list_no = index + 1;
            return [
              item.list_no,
              item.order_area_name,
              item.zone_master_name,
              item.zone_master_remark,
              item.order_area_active === true ? 'เปิดการใช้งาน' : 'ปิดการใช้งาน'
            ];
          });
          ExportExcel(
            data,
            workSheetColumnsName,
            "ข้อมูลพื้นที่สั่งงาน",
            "ข้อมูลพื้นที่สั่งงาน.xlsx",
          );
          setLoading(false);
        } else {
          setLoading(false);
          AlertWarning("ไม่พบข้อมูลที่ต้องการส่งออก");
        }
      })
      .catch((err) => {
        AlertError(err);
      });
  };


  return (
    <>
      {/* <label>บันทึกรายละเอียดงานประจำวัน</label> */}
      <Card
        variant="outlined"
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          borderRadius: "10px",
        }}
      >
        {HeaderPage()}
        <DataTable
            exportButton={false}
            columns={columns}
            data={filteredItems}
            width="100%"
            countRowData={areaData.length}
            pageSize={50}
        />
      </Card>
      {openDialogformEdit && (
        <AddWorkArea
          onCancel={() => setOpenDialogformEdit(false)}
          open={openDialogformEdit}
          documentId={variable.documentId}
        />
      )}
      {openDialogformAdd && (
        <AddWorkArea
          onCancel={() => {setOpenDialogformAdd(false)}}
          open={openDialogformAdd}
          documentId={0}
        />
      )}
      <Loading open={variable.loading} />
    </>
  );
}

export default WorkArea;
